import angular from 'angular';
import editUserInTeam from './edit-user-in-team';
import editUserInProject from './edit-user-in-project';
import assignUserToProject from './assign-user-to-project';
import assignProjectToUser from './assign-project-to-user';
import assignUserToTeam from './assign-user-to-team';
import assignTeamToUser from './assign-team-to-user';


const userPopupService = angular.module('ttb.core.popups.userPopup.service', [
    editUserInTeam,
    editUserInProject,
    assignUserToProject,
    assignProjectToUser,
    assignUserToTeam,
    assignTeamToUser,
])
    .factory('userPopupService', ['$uibModal','$document',
        ($uibModal,$document) => {
            const openModal = (component, resolve, appendTo) => {
                $document[0].activeElement.blur()
                const modalInstance = $uibModal.open({
                    component,
                    resolve,
                    appendTo,
                    size: 'lg',
                    backdrop: 'static',
                    windowClass: 'user-popup'
                });
                return modalInstance.result.catch(e => { });
            };

            const openUserInTeam = ({userId, teamId}) => openModal('editUserInTeam', {
                userId: () => userId,
                teamId: () => teamId,
            });

            const openUserInProject = ({userId, projectId}, appendTo) => openModal('editUserInProject', {
                userId: () => userId,
                projectId: () => projectId,
            }, appendTo);

            const openProjectToUser = ({
                                           groupId,
                                           userId,
                                       }) => openModal('assignProjectToUser', {groupId, userId});

            const openTeamToUser = ({
                                        groupId,
                                        userId,
                                        parent,
                                    }) => openModal('assignTeamToUser', {groupId, userId, parent});

            const openUserToProject = ({projectId}) => openModal('assignUserToProject', {projectId: () => projectId});

            const openUserToTeam = ({ teamId }) => openModal('assignUserToTeam', { teamId: () => teamId });

            return {
                openUserInTeam,
                openUserInProject,
                openProjectToUser,
                openTeamToUser,
                openUserToProject,
                openUserToTeam,
            };
        }])
    .name;

export default userPopupService;



// WEBPACK FOOTER //
// ./components/popups/user-popup/user-popup.service.js